<template>
    <div :class="$style.receiptGroupFragment">
        <h2>{{ label }}</h2>
        <p :class="$style.descriptionSmall" v-if="hasDescriptionSlotContent"><slot name="description"></slot></p>
        <table :class="$style.receiptTable">
            <slot></slot>
        </table>
    </div>
</template>

<script>
    export default {
        name: "receipt-group-fragment",
        props : {
            label: {type: String, required: true}
        },
        computed: {
          hasDescriptionSlotContent() {
              return this.$slots && this.$slots.description && this.$slots.description.length;
            }
        },
    }
</script>

<style module lang="scss">
    @import "../../style/modules/input.module";

    .receiptGroupFragment {
        display: flex;
        flex-direction: column;

      h2 {
        font-family: $font-family-bold;
        margin: 0;
      }
    }

    .receiptTable {
        margin-top: rem-calc($spacing-xl);
        width: 100%;
        border-collapse: collapse;
    }
</style>